import * as React from 'react';
import loadable from '@loadable/component';
import withMicroFrontendProps, { SEOHead } from 'Common/Microfrontend';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useBellaPush from 'Client/hooks/useBellaHistoryPush';
import useBellaTranslator from 'Client/hooks/useTranslator';
import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';
import { UnsupportedBrowser, useUnsupportedBrowser } from 'Client/components/UnsupportedBrowser';
import useRouter from 'Client/hooks/useRouter';

const InteriorDesignService = loadable(() => import('mf-interior-design-service/Main'), { ssr: false });

const InteriorDesignServiceWithBellaProps = withMicroFrontendProps(InteriorDesignService, 'mf-interior-design-service');

const InteriorDesignServiceMicroFrontend = () => {
    const { p100IdsClientSideNavigation } = useFeatureToggle();
    const t = useBellaTranslator();
    const { isAppWebviewPage } = useRouter();
    const isUnsupportedBrowser = useUnsupportedBrowser();

    const appshellPush = useBellaPush();

    if (!p100IdsClientSideNavigation) {
        return appshellPush('/');
    }

    return (
        <React.Fragment>
            <SEOHead>
                <title>{isAppWebviewPage ? t('Studio Title - Apps') : t('WestwingNow - Interior Service')}</title>
                <meta
                    name={SEO_CONSTANTS.descriptionMetaName}
                    content={t('WestwingNow - Interior Service description')}
                />
            </SEOHead>
            {isUnsupportedBrowser ? <UnsupportedBrowser /> : <InteriorDesignServiceWithBellaProps />}
        </React.Fragment>
    );
};

export default InteriorDesignServiceMicroFrontend;
